export const siteConfig = {
endereco: {
    rua: 'Rua Mariluz',
    numero: '149',
    bairro: 'Vila São Judas Tadeu',
    cidade: 'Guarulhos',
    cep: '07060-161',
    estado: 'SP',
    shareLink: 'https://goo.gl/maps/JBpHJRa1hLJwr1PD6'

},
telefones: {
    numero: '11 2459 1421',
    whatsapp: '11 94830 8564'
},
email: {
    emailUm: 'contato@zapparoliodontologia.com.br' 
}
}
